import * as React from "react";
import { ChronologyListActions } from "./chronologyListActions";
import { ChronologyListTable } from "./chronologyListTable";
import { type DocumentChronology } from "@/types/chronology";
import { RightSidebarContentType } from "@/views/chronology/components/rightSidebar/types";
import { compareAsc } from "date-fns";
import { useToggle } from "react-use";

interface ChronologyListProps {
  documentChronology: DocumentChronology;
  setContentType: (contentType: RightSidebarContentType) => void;
  selectedFse: string[];
}

export const ChronologyList: React.FC<ChronologyListProps> = ({ selectedFse, setContentType, documentChronology }) => {
  const chronoentries = [...documentChronology.chronoentries].filter(entry => selectedFse.includes(entry.fse_id));

  const rows = chronoentries.sort((a, b) => {
    const dateA =
      a.year !== -1 ? `${a.year}-${a.month}-${a.day || 1}` : `${a.nlp_year}-${a.nlp_month}-${a.nlp_day || 1}`;

    const dateB =
      b.year !== -1 ? `${b.year}-${b.month}-${b.day || 1}` : `${b.nlp_year}-${b.nlp_month}-${b.nlp_day || 1}`;

    return compareAsc(dateA, dateB);
  });
  const [showAddRow, handleAddRow] = useToggle(false);

  const handleNarrative = () => {
    setContentType("narrative");
  };

  return (
    <div className="mr-3 flow-root">
      <div className="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <ChronologyListTable
              documentChronology={documentChronology}
              showAddRow={showAddRow}
              chronoRecords={rows}
              toggleAddRow={handleAddRow}
              documentId={documentChronology.document_id}
            />
          </div>
          <ChronologyListActions
            documentChronology={documentChronology}
            handleNarrative={handleNarrative}
            handleAddRow={handleAddRow}
          />
        </div>
      </div>
    </div>
  );
};
